import { Component, inject, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatCard, MatCardContent, MatCardFooter } from '@angular/material/card';
import { MatList, MatListItemTitle } from '@angular/material/list';
import { RedemptionResponse } from '../../../core/Interfaces/Http/redemption-response';
import { ProductItemComponent } from '../product-item/product-item.component';
import { MatFabButton } from '@angular/material/button';
import { ConfirmDialogComponent } from '../../dialog/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RedemptionService } from '../../../core/services/redemption.service';
import { RedemptionStatusEnum } from '../../../core/enums/redemption-status.enum';

@Component({
  selector: 'app-fetch',
  imports: [
    DatePipe,
    MatCard,
    MatCardContent,
    MatList,
    MatListItemTitle,
    ProductItemComponent,
    MatCardFooter,
    MatFabButton,
  ],
  templateUrl: './fetch.component.html',
  styleUrl: './fetch.component.scss',
})
export class FetchComponent {
  private redemptionService = inject(RedemptionService);

  @Input() redemption!: RedemptionResponse;
  readonly dialog = inject(MatDialog);

  openConfirmDialog(status: RedemptionStatusEnum, context: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '100ms',
      data: {
        context: context,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.redemptionService.updateStatus(
          this.redemption.redemption.orderID,
          status,
        );
      }
    });
  }

  protected readonly RedemptionStatusEnum = RedemptionStatusEnum;
}
